// extracted by mini-css-extract-plugin
export default {"popup":"popup__S762C","closeButton":"closeButton__9jm0y","closeBackground":"closeBackground__QTA9V","wrapper":"wrapper__9N0Dq","content":"content__Jehzs"};